(function () {
  'use strict';

  /* @ngdoc object
   * @name rlog
   * @description
   *
   */
  angular
    .module('rlog', [
      'ui.router',
      'knalli.angular-vertxbus'
    ]);
}());
